import GoldenScale from "../../../core/assets/oot/gshd/golden-scale_32x32.png";
import SilverScale from "../../../core/assets/oot/gshd/scale_32x32.png";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import StaticItem from "../../../core/items/StaticItem";
import UpgradeItem from "../../../core/items/UpgradeItem";
import OotItem, { DbItemProps } from "./OotItem";
import { SimpleItemProps } from "./SimpleItemProps";

const id = "OoT_Scale"


let titles = ["Silver Scale", "Golden Scale"];

let labels = ["", ""]

let images = [SilverScale, GoldenScale]

const ScaleItem = () => {


    return <OotItem id={id}>
        {({ updateOotItem, item }) => {

            return <UpgradeItem id={id} image={images} title={titles}
                updateItem={updateOotItem}
                item={item}
            />

        }}</OotItem>

}

export default ScaleItem;

export const SimpleScaleItem  = (props: SimpleItemProps) => {


    return <StaticItem
        image={SilverScale}
        onClick={props.onClick}
        name={id}
    />


}

export const DbScaleItem = (props: DbItemProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultScaleItem;


    return <UpgradeItem
        item={item}
        updateItem={props.update}
        image={images}
        id={id}
        isObtained={item.isObtained}
        title={titles} upgradeLabel={labels}
    />


}

const DefaultScaleItem : ItemLightDto = {
    id: id,
    title: id,
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}